export default {
  'customNotifications.title': 'Notificaciones Personalizadas',

  'notification.status.Pending': 'Pendiente',
  'notification.status.Finished': 'Finalizado',
  'notification.status.Rejected': 'Rechazado',
  'notification.status.Overdue': 'Vencido',
  'notification.status.Skipped': 'Omitido',
  'notification.status.Error': 'Error',
  'notification.status.Execution': 'Ejecución',

  'notification.addedUsers': 'Usuario Agregado',

  'customNotifications.form.isSendToApplicantEnabled': '¿Enviar al Solicitante?',
  'customNotifications.form.form': 'Formulario',
  'customNotifications.form.field': 'Campo',
};
